import { Injectable } from "@angular/core";
import { ActionWithPayload } from "@obg/ngrx-utils";

export const ACTION_PREFIX = "[EmailLogin]";
export const EMAIL_LOGIN_ACTION_TYPE = {
	/**
	 * Set email login
	 */
	setEmailLogin: `${ACTION_PREFIX} Set email login`,
};

@Injectable({
	providedIn: "root",
})
export class EmailLoginAction {
	setLoginEmail(payload: string): ActionWithPayload {
		return {
			type: EMAIL_LOGIN_ACTION_TYPE.setEmailLogin,
			payload,
		};
	}
}
